import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { TOKENS } from '../theme';

export default function ConfirmDeleteDialog({
  open,
  onClose,
  onConfirm,
  title = 'Delete this entry?',
  subtitle,
}) {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              background: TOKENS.red100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <WarningAmberIcon sx={{ color: TOKENS.red600 }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ fontSize: 11, color: TOKENS.slate500 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}
      >
        <Box
          sx={{
            p: 1,
            borderRadius: 1,
            border: '1px solid',
            borderColor: TOKENS.amber200,
            background: TOKENS.amber50,
          }}
        >
          <Typography sx={{ fontSize: 11, color: TOKENS.amber900 }}>
            This action will be permanently logged in the audit trail.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{
            background: TOKENS.red600,
            '&:hover': { background: TOKENS.red700 },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
